module.exports = __webpack_public_path__ + "static/img/4.13f7c98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin/4.png
// module id = g8h2
// module chunks = 0